module.exports = __webpack_public_path__ + "media/images/Amsale-MOTGB-87ae7e9d.webp";